import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './Core_Data_Room_Document.css';

const Core_Data_Room_Document = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"CORE_DATA_ROOM_DOCUMENT",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	CORE_DATA_ROOM_DOCUMENT:-1
  });


  const [CORE_DATA_ROOM_DOCUMENT, setCORE_DATA_ROOM_DOCUMENT] = React.useState(null);
  const [CORE_DATA_ROOM_DOCUMENT_D, setCORE_DATA_ROOM_DOCUMENT_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Core Data Room Document');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/Core_Data_Room_Document',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewCORE_DATA_ROOM_DOCUMENT(clientInfo,"OpenNew");

		navigate('/Core_Data_Room_Document',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Data_Room_Document_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutCORE_DATA_ROOM_DOCUMENT(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostCORE_DATA_ROOM_DOCUMENT(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewCORE_DATA_ROOM_DOCUMENT(clientInfo,"OpenNew");
		}
		navigate('/Core_Data_Room_Document',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Data_Room_Document_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Data_Room_Document_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Data_Room_Document_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
		if(Temp_Data2.status!="New"){
			handleDeleteCORE_DATA_ROOM_DOCUMENT(Temp_Data2);
			navigate('/Core_Data_Room_Document#New',{replace:true});
		} 
		else 
			navigate('/Core_Data_Room_Document',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Data_Room_Document',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Data_Room_Document',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Data_Room_Document',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Data_Room_Document',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!CORE_DATA_ROOM_DOCUMENT) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_${i}_SECTION`;
	  const headerId = `#PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {
    if ($('#Table3').length > 0) window.DataTableScript('#Table3');

    initRef.current.dataTableHandled = true;
  }  

  }, [CORE_DATA_ROOM_DOCUMENT]) ;


  
  
  var Ids = [];
  for(var Ele in CORE_DATA_ROOM_DOCUMENT){
	  for(var Sec in CORE_DATA_ROOM_DOCUMENT[Ele]){
		if(Sec == "id")
			Ids.push(CORE_DATA_ROOM_DOCUMENT[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(CORE_DATA_ROOM_DOCUMENT[Ele]["status"]);
		else if(Array.isArray(CORE_DATA_ROOM_DOCUMENT[Ele][Sec]))
			  for(var Row in CORE_DATA_ROOM_DOCUMENT[Ele][Sec])  // Convert to CORE_DATA_ROOM_DOCUMENT[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in CORE_DATA_ROOM_DOCUMENT[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["CORE_DATA_ROOM_DOCUMENT"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewCORE_DATA_ROOM_DOCUMENT(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DATA_ROOM_DOCUMENT`).then((response1) => {
		if(!CORE_DATA_ROOM_DOCUMENT) 
			setCORE_DATA_ROOM_DOCUMENT(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DATA_ROOM_DOCUMENT_D`).then((response2) => {
			setCORE_DATA_ROOM_DOCUMENT_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddCORE_DATA_ROOM_DOCUMENT_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewCORE_DATA_ROOM_DOCUMENT = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DATA_ROOM_DOCUMENT/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setCORE_DATA_ROOM_DOCUMENT(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataCORE_DATA_ROOM_DOCUMENT = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DATA_ROOM_DOCUMENT/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutCORE_DATA_ROOM_DOCUMENT = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DATA_ROOM_DOCUMENT/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostCORE_DATA_ROOM_DOCUMENT = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DATA_ROOM_DOCUMENT', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteCORE_DATA_ROOM_DOCUMENT = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_DATA_ROOM_DOCUMENT', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_0"]=value;
	//handleAddCORE_DATA_ROOM_DOCUMENT(Temp_Data,App_Data['CORE_DATA_ROOM_DOCUMENT']);
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_0",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM_DOCUMENT(Temp_Data);
    setCORE_DATA_ROOM_DOCUMENT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_1"]=value;
	//handleAddCORE_DATA_ROOM_DOCUMENT(Temp_Data,App_Data['CORE_DATA_ROOM_DOCUMENT']);
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_1",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM_DOCUMENT(Temp_Data);
    setCORE_DATA_ROOM_DOCUMENT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_2"]=value;
	//handleAddCORE_DATA_ROOM_DOCUMENT(Temp_Data,App_Data['CORE_DATA_ROOM_DOCUMENT']);
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_2",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM_DOCUMENT(Temp_Data);
    setCORE_DATA_ROOM_DOCUMENT(Temp_Data);
 }; 
  

const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_3"]=value;
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_3",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM_DOCUMENT(Temp_Data);
    setCORE_DATA_ROOM_DOCUMENT(Temp_Data);
	//handleAddCORE_DATA_ROOM_DOCUMENT(Temp_Data,App_Data['CORE_DATA_ROOM_DOCUMENT']);
  }; 
  

    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_4"]=value;
	//handleAddCORE_DATA_ROOM_DOCUMENT(Temp_Data,App_Data['CORE_DATA_ROOM_DOCUMENT']);
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_4",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM_DOCUMENT(Temp_Data);
    setCORE_DATA_ROOM_DOCUMENT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
	Temp_Data["2"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_0"]=value;
	//handleAddCORE_DATA_ROOM_DOCUMENT(Temp_Data,App_Data['CORE_DATA_ROOM_DOCUMENT']);
	Form_Data_onChange("2","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_0",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM_DOCUMENT(Temp_Data);
    setCORE_DATA_ROOM_DOCUMENT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
	Temp_Data["2"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_1"]=value;
	//handleAddCORE_DATA_ROOM_DOCUMENT(Temp_Data,App_Data['CORE_DATA_ROOM_DOCUMENT']);
	Form_Data_onChange("2","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_1",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM_DOCUMENT(Temp_Data);
    setCORE_DATA_ROOM_DOCUMENT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
	Temp_Data["2"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_2"]=value;
	Form_Data_onChange("2","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_2",value,Temp_Data);
    setCORE_DATA_ROOM_DOCUMENT(Temp_Data);
  }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
	Temp_Data["2"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_3"]=value;
	Form_Data_onChange("2","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_3",value,Temp_Data);
    setCORE_DATA_ROOM_DOCUMENT(Temp_Data);
  }; 
  

const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_0"]=value;
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_0",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM_DOCUMENT(Temp_Data);
    setCORE_DATA_ROOM_DOCUMENT(Temp_Data);
	//handleAddCORE_DATA_ROOM_DOCUMENT(Temp_Data,App_Data['CORE_DATA_ROOM_DOCUMENT']);
  }; 
  

    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_1"]=value;
	//handleAddCORE_DATA_ROOM_DOCUMENT(Temp_Data,App_Data['CORE_DATA_ROOM_DOCUMENT']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_1",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM_DOCUMENT(Temp_Data);
    setCORE_DATA_ROOM_DOCUMENT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_2"]=value;
	//handleAddCORE_DATA_ROOM_DOCUMENT(Temp_Data,App_Data['CORE_DATA_ROOM_DOCUMENT']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_2",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM_DOCUMENT(Temp_Data);
    setCORE_DATA_ROOM_DOCUMENT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_3"]=value;
	//handleAddCORE_DATA_ROOM_DOCUMENT(Temp_Data,App_Data['CORE_DATA_ROOM_DOCUMENT']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_3",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM_DOCUMENT(Temp_Data);
    setCORE_DATA_ROOM_DOCUMENT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_4"]=value;
	//handleAddCORE_DATA_ROOM_DOCUMENT(Temp_Data,App_Data['CORE_DATA_ROOM_DOCUMENT']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_4",value,Temp_Data);
 	//handleLastDataCORE_DATA_ROOM_DOCUMENT(Temp_Data);
    setCORE_DATA_ROOM_DOCUMENT(Temp_Data);
 }; 
  

const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));  
  Temp_Data['3'][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_0"] = value;
  setCORE_DATA_ROOM_DOCUMENT(Temp_Data);
};


const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_1_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));  
  Temp_Data['3'][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_1"] = value;
  setCORE_DATA_ROOM_DOCUMENT(Temp_Data);
};

  


const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_2_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
	Temp_Data["3"][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_2"]=value ? true : false;
    setCORE_DATA_ROOM_DOCUMENT(Temp_Data);
	//handleAddCORE_DATA_ROOM_DOCUMENT(Temp_Data,App_Data['CORE_DATA_ROOM_DOCUMENT']);
  }; 

  


const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_3_Change = (event,index) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
	Temp_Data["3"][index]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_3"]=value ? true : false;
    setCORE_DATA_ROOM_DOCUMENT(Temp_Data);
	//handleAddCORE_DATA_ROOM_DOCUMENT(Temp_Data,App_Data['CORE_DATA_ROOM_DOCUMENT']);
  }; 




 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!CORE_DATA_ROOM_DOCUMENT) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {
	  case('3'):
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_0']='';
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_1']='';
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_2']='';
	    newRow['PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_3']='';
	    break;

  }


  const updatedCORE_DATA_ROOM_DOCUMENT =JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
  updatedCORE_DATA_ROOM_DOCUMENT[Sec] = [...updatedCORE_DATA_ROOM_DOCUMENT[Sec], newRow];
  setCORE_DATA_ROOM_DOCUMENT(updatedCORE_DATA_ROOM_DOCUMENT);
};

const handleDeleteRow = (sec,index) => {
  const updatedCORE_DATA_ROOM_DOCUMENT = JSON.parse(JSON.stringify(CORE_DATA_ROOM_DOCUMENT));
  updatedCORE_DATA_ROOM_DOCUMENT[sec].splice(index, 1);
  setCORE_DATA_ROOM_DOCUMENT(updatedCORE_DATA_ROOM_DOCUMENT);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Core Data Room Document`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Document ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Document ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_0" type="text" className="form-control" placeholder="Document ID" value={CORE_DATA_ROOM_DOCUMENT["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_0`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Document ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Data Room ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_1" type="text" className="form-control" placeholder="Data Room ID" value={CORE_DATA_ROOM_DOCUMENT["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_1`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Data Room ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_2" type="text" className="form-control" placeholder="Asset ID" value={CORE_DATA_ROOM_DOCUMENT["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_2`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Document Category`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_3"  value={CORE_DATA_ROOM_DOCUMENT["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_3`]} onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_3_Change} className="form-control" name="Document Category"  >
						  <option value="Title">Title</option>
						  <option value="Appraisal">Appraisal</option>
						  <option value="Survey">Survey</option>
						  <option value="Environmental">Environmental</option>
						  <option value="Zoning">Zoning</option>
						  <option value="Permit">Permit</option>
						  <option value="Insurance">Insurance</option>
						  <option value="Lease">Lease</option>
						  <option value="Financial">Financial</option>
						  <option value="Tax">Tax</option>
						  <option value="Legal">Legal</option>
						  <option value="Inspection">Inspection</option>
						  <option value="Construction">Construction</option>
						  <option value="Auction">Auction</option>
						  <option value="Investor Report">Investor Report</option>
						  <option value="Other">Other</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Document Category
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '180ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Document Title`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_4" type="text" className="form-control" placeholder="Document Title" value={CORE_DATA_ROOM_DOCUMENT["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_4`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_1_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '180ch' }}>
						 {t(`Enter Document Title`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Document Link`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Document Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_0" type="text" className="form-control" placeholder="Document Link" value={CORE_DATA_ROOM_DOCUMENT["2"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_0`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Document Link`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Version Number`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_1" type="text" className="form-control" placeholder="Version Number" value={CORE_DATA_ROOM_DOCUMENT["2"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_1`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter Version Number`)}
                     </div>
                  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Effective Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_2" type="date"  value={CORE_DATA_ROOM_DOCUMENT["2"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_2`]} 
							onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_2_Change} style={{ borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_2"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Effective Date
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Expiration Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_3" type="date"  value={CORE_DATA_ROOM_DOCUMENT["2"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_3`]} 
							onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_3_Change} style={{ borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_2_3"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Expiration Date
					  </div>
				  </div>
               </div>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_HEADER">{t(`Document Rule Audience`)} <span className="toggle-icon">^</span></h2>
            <div  id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('3')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table3" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Document Rule Audience`)}</th>
                        <th>{t(`Visibility Level`)}</th>
                        <th>{t(`Required For Offering`)}</th>
                        <th>{t(`Verified`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {CORE_DATA_ROOM_DOCUMENT['3'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_0`]} data-search={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_0"  onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_0_Change(ev, i)}  className="form-control" value={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_0`]} name="Document Rule Audience">
						  <option value="Internal">Internal</option>
						  <option value="Compliance">Compliance</option>
						  <option value="Investor">Investor</option>
						  <option value="Public">Public</option>
						  <option value="Restricted">Restricted</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_1`]} data-search={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_1`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_1"  onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_1_Change(ev, i)}  className="form-control" value={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_1`]} name="Visibility Level">
						  <option value="Internal Only">Internal Only</option>
						  <option value="Compliance Only">Compliance Only</option>
						  <option value="Investor Visible">Investor Visible</option>
						  <option value="Public">Public</option>
						  <option value="Restricted">Restricted</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_2"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_2_Change(ev, i)} 
								  checked={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_2`]  === true? e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_2`] : false  } />
						   </label>
						</td>
                        <td>
						   <label style={{ display: 'inline-block', width: '100%', cursor: 'pointer' }}>
							  <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_3"  type="checkbox" style={{ marginRight: '5px' }} onChange={(ev) => PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_3_Change(ev, i)} 
								  checked={e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_3`]  === true? e[`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_3_3`] : false  } />
						   </label>
						</td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_0"  value={CORE_DATA_ROOM_DOCUMENT["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_0`]} onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_1" type="text" className="form-control" placeholder="Created By" value={CORE_DATA_ROOM_DOCUMENT["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_1`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_2" type="text" className="form-control" placeholder="Created At" value={CORE_DATA_ROOM_DOCUMENT["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_2`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_3" type="text" className="form-control" placeholder="Updated By" value={CORE_DATA_ROOM_DOCUMENT["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_3`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_4" type="text" className="form-control" placeholder="Updated At" value={CORE_DATA_ROOM_DOCUMENT["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_4`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_DATA_ROOM_DOCUMENT_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default Core_Data_Room_Document;  